import React from "react";
import { useNavigate } from "react-router-dom";
import { SCROLL_OFFSET, ARTICLE_COLUMN, BODY_SM, SOFT_PANEL } from "./sections";

const UnlimitedDictationSection = () => {
  const navigate = useNavigate();

  return (
    <section
      id="unlimited-dictation"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className={ARTICLE_COLUMN}
    >
      {/* Copy on the left, single action on the right; stacks below md */}
      <div
        className={`${SOFT_PANEL} flex flex-col gap-[20px] p-[24px] sm:p-[32px] md:flex-row md:items-center md:justify-between md:gap-[32px]`}
      >
        <div className="min-w-0">
          <h2 className="font-jakarta text-[20px] font-bold leading-[1.3] tracking-[-0.3px] text-[#0A0D16] sm:text-[22px]">
            Ready for Unlimited Dictation?
          </h2>

          <p className={`mt-[8px] max-w-[460px] ${BODY_SM}`}>
            ZT Pro unlocks unlimited words, unlimited audio transcription, and
            custom prompt creation for $8/month.
          </p>
        </div>

        <button
          type="button"
          onClick={() => navigate("/pricing")}
          className="inline-flex shrink-0 cursor-pointer items-center justify-center rounded-[12px] bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] px-[22px] py-[11px] font-inter text-[14px] font-semibold leading-[20px] text-white shadow-[0_4px_18px_rgba(58,177,246,0.35)] transition-all duration-300 hover:-translate-y-0.5 hover:from-[#33A2E5] hover:to-[#386FE8] hover:shadow-xl"
        >
          See Pricing
        </button>
      </div>
    </section>
  );
};

export default UnlimitedDictationSection;
